import { Component, OnInit } from '@angular/core';
import { BuildVersionEnvironmentResponse } from '@biletix/core/models/build-version-environment-response.dto';
import { ActuatorService } from '@biletix/core/services/actuator.service';

@Component({
    standalone: false,
    selector: 'btx-actuator',
    templateUrl: './actuator.component.html',
    styleUrls: ['./actuator.component.scss']
})
export class ActuatorComponent implements OnInit {
    web: BuildVersionEnvironmentResponse | undefined;
    webbox: BuildVersionEnvironmentResponse | undefined;


    constructor(private actuatorService: ActuatorService) { }

    ngOnInit(): void {
        this.loadInfo();
    }

    loadInfo(): void {

        this.actuatorService.getAllBuildInfos().subscribe(data => {
            this.web = data?.web;
            this.webbox = data?.webbox;
        });

    }
}